import React from "react";
import Card from "./Card";
import web__development from "../images/programming.png";
import web_design from "../images/design.png";
import problem__sol from "../images/puzzle.png";
import Resume from "./Resume";

function What__I__Do() {
  return (
    <div
      className=" pt-[130px] pb-[130px]  md:pl-[70px] md:pr-[70px] pl-2 pr-2"
      uk-scrollspy="cls: uk-animation-slide-bottom; target: .uk-card; delay: 300; repeat: true"
    >
      <p className="text-center">
        <span className="p-2 about__me__title ">What I Do?</span>
      </p>
      <h1 className="text-center know__me__title mt-6 " style={{fontSize: 'clamp(2rem,4vw,6rem)'}}>
        How I can help your next project
      </h1>
      <div className=" uk-card flex flex-col jystify-center items-center md:flex md:flex-row md:justify-around md:items-center mt-[80px] mb-[80px]">
        <Card icon={web__development} title="Web Development" />
        <Card icon={web_design} title="Web Design" />
        <Card icon={problem__sol} title="Problem Solver" />
      </div>
      <div className=" uk-card flex flex-col jystify-center items-center md:flex md:flex-row md:justify-around md:items-center mt-[80px] mb-[80px]">
        <Card icon={web__development} title="Web Development" />
        <Card icon={web_design} title="Web Design" />
        <Card icon={problem__sol} title="Problem Solver" />
      </div>
      {/* <div className=" uk-card flex flex-col jystify-center items-center md:flex md:flex-row md:justify-around md:items-center mt-[80px]">
        <Card icon={web__development} title="Web Development" />
        <Card icon={web_design} title="Web Design" />
        <Card icon={problem__sol} title="Problem Solver" />
      </div> */}
    </div>
  );
}

export default What__I__Do;
